import Accordion from '@/components/base/Accordion';
import { faqs } from '@/mocks/content';

export default function FAQSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-start">
          <div className="lg:col-span-1">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-500">FAQ</span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-4 leading-tight">
              Frequently Asked<br />Questions
            </h2>
            <p className="text-sm text-foreground-500 mt-4 leading-relaxed">
              Everything you need to know about using the Vigorbuy Spreadsheet to shop smarter and safer.
            </p>
          </div>
          <div className="lg:col-span-2">
            <Accordion items={faqs} />
          </div>
        </div>
      </div>
    </section>
  );
}